// =====================================================================================================================
// NAV ITEM
//
//  The little size menu items for the website.
//

import { EventManager, HorizContainer, Ui} from "@stratisopt/platform";
import { UiFactory } from "@stratisopt/platform";

export class NavItem extends HorizContainer {

    // =================================================================================================================
    // CONSTRUCTORS
    //

    // Create and initialize a new instance
    public static create(json:any):NavItem {
        let ui = new NavItem();
        ui.init(json);
        return ui;
    }

    // Initialize this instance
    public init(json:any) {

        // Mine out nav item specific properties
        const readableText = json.value;
        const navPath = json.navPath;

        if (readableText === undefined)
            EventManager.publish(this.constructor.name, "Warning: No \"value\" provided for Nav Item");

        if (navPath === undefined)
            EventManager.publish(this.constructor.name, "Warning: No \"navPath\" provided for Nav Item");


        let newJson = this.createJson(readableText, navPath);

        // Initialize the super
        super.init(newJson);
        UiFactory.addChildren(this, newJson);

        // Update with json overrides (if they exist)
        if (json !== undefined) {
            this.setFieldsFromJson(json);           
        }
    }


    // =================================================================================================================
    // VIEW
    //

    private createJson(readableText:string = "No text given", navPath = ""):any {
        let json:any = {
            sizeX:'1*', sizeMinX:'content', pad:Ui.theme.SPACING_Nest,
            effect:'hover', cursor:'pointer', 
            onTouch:'UI.select; Ui.select '+ navPath, 
            onSelect:'Ui.Set backColor, '+Ui.theme.COLOR_ProjectsWindow+'; UI.Set textColor, '+ Ui.theme.COLOR_LogoOrange, 
            onDeselect:'Ui.Set backColor, transparent; UI.Set textColor, '+Ui.theme.COLOR_FontNeutral,
            textColor:Ui.theme.COLOR_FontNeutral, borderRadius:'6px',
            children:[
                {type:'text', textSize:Ui.theme.SIZE_FontNeutral, textShadow:Ui.theme.COLOR_FontShadow, value:readableText},
            ]   
        };
        return json;
    }

}
